import React, { useEffect, useState } from "react";
import { useField, Field, FieldProps } from "formik";
import { Tokens } from "@chainsafe/web3-context/dist/context/tokensReducer";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
// import Select from "react-select";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SelectChangeEvent } from "@mui/material/Select";
import { v4 as uuidv4 } from "uuid";
import { Select } from "../../components";

interface ITokenSelectInput extends FieldProps {
  tokens: Tokens;
  sync?: (value: string) => void;
}

const TokenSelectInput: React.FC<any> = ({
  className,
  label,
  name,
  tokens,
  sync,
  options,
  disabled,
  value,
  handleBlur,
  setFieldValue,
}: any) => {
  const [field, , helpers] = useField(name);
  const [synced, setSynced] = useState();
  useEffect(() => {
    if (sync && field.value !== synced) {
      setSynced(field.value);
      if (field.value !== "") {
        sync(field.value);
      }
    }
    // eslint-disable-next-line
  }, [field]);

  useEffect(() => {
    // If there is only one token, auto select
    if (Object.keys(tokens).length === 1 && field.value === "") {
      helpers.setValue(Object.keys(tokens)[0]);
    }
  }, [tokens, helpers, field.value]);

  return (
    <Box width="100%">
      <Select
        onChange={(option) => setFieldValue("token", option.target.value)}
        value={value || ""}
        disabled={disabled}
        options={options}
        label={label}
      />
    </Box>
  );
};

export default TokenSelectInput;
